<template>
  <div>
    <a-breadcrumb>
      <a-breadcrumb-item>系统设置</a-breadcrumb-item>
      <a-breadcrumb-item>行业领域管理</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="space-20">
      <a-button type="primary" @click="showModel = 'addSector'">新增</a-button>
    </div>
    <a-table :loading="loading" :columns="columns" :dataSource="list" :rowKey="row => row.id">
      <span slot="action" slot-scope="row">
        <a-button
          @click="
            currentRow = row;
            showModel = 'editSector';
          "
          size="small"
          type="primary"
          >编辑</a-button
        >
        <a-divider type="vertical" />
        <a-button @click="handleHideItem(row)" size="small" type="danger" v-if="row.status === 'NORMAL'">隐藏</a-button>
        <a-button @click="handleResetItem(row)" size="small" type="primary" v-else>展示</a-button>
      </span>
    </a-table>
    <a-modal title="新增阶段" @cancel="closeModel" :visible="showModel == 'addSector'" width="400px">
      <a-form>
        <a-form-item label="名称：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="sectorInfo.name" placeholder="阶段名称"></a-input>
        </a-form-item>
        <a-form-item label="排序：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input-number :step="0.5" v-model="sectorInfo.sortOrder" />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary" @click="handleItem('add')">确定</a-button>
      </template>
    </a-modal>
    <a-modal title="编辑阶段" @cancel="closeModel" :visible="showModel == 'editSector'" width="400px">
      <a-form>
        <a-form-item label="名称：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input v-model="currentRow.name" placeholder="阶段名称"></a-input>
        </a-form-item>
        <a-form-item label="排序：" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input-number :step="0.5" v-model="currentRow.sortOrder" />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary" @click="handleItem('edit')">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { sectorList, hideOrReset, sectorAction } from '@/api/sector.js';
const columns = [
  { title: '行业名称', dataIndex: 'name' },
  { title: 'RankScore', dataIndex: 'sortOrder', align: 'center' },
  { title: '更新时间', dataIndex: 'createAt', align: 'center' },
  { title: '操作', align: 'center', scopedSlots: { customRender: 'action' } }
];
export default {
  data() {
    return {
      loading: true,
      columns,
      list: [],
      currentRow: {},
      showModel: '',
      sectorInfo: {
        name: '',
        sortOrder: 0
      }
    };
  },
  methods: {
    closeModel() {
      this.showModel = '';
    },
    getList() {
      this.loading = true;
      sectorList().then(res => {
        this.list = res.data;
        this.loading = false;
      });
    },
    handleHideItem(row) {
      this.$confirm({
        title: `隐藏后将从sector列表中隐去，确定隐藏行业领域“${row.name}”吗？`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          hideOrReset({ sectorId: row.id, status: -1 }).then(res => {
            if (res.code === 200) {
              this.$message.success(res.data);
              this.getList();
            }
          });
        }
      });
    },
    async handleResetItem(row) {
      try {
        let res = await hideOrReset({ sectorId: row.id, status: 0 });
        if (res.code === 200) {
          this.$message.success(res.data);
          this.getList();
        }
      } catch (err) {
        console.log(err);
      }
    },
    handleItem(type) {
      let data = Object.assign({}, this.sectorInfo);
      if (type === 'edit') {
        data.name = this.currentRow.name;
        data.sortOrder = this.currentRow.sortOrder;
        data.id = parseInt(this.currentRow.id);
      }
      sectorAction(data).then(res => {
        if (res.code === 200) {
          this.closeModel();
          this.getList();
          this.$message.success(res.data || 'success');
          !data.id && (this.sectorInfo = { name: '', sortOrder: 0 });
        }
      });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
